"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DotWithLabel = void 0;
const react_1 = __importDefault(require("react"));
const recharts_1 = require("recharts");
const getTextWidth_1 = require("@/utils/getTextWidth");
const CustomLabel = ({ viewBox, text, color, textColor, labelColor, verticalOffset }) => {
    if (!viewBox || !('x' in viewBox) || !('y' in viewBox))
        return null;
    const { x, y } = viewBox;
    if (x === undefined || y === undefined)
        return null;
    const fontSize = 12;
    const width = (0, getTextWidth_1.getTextWidth)(text, fontSize);
    return (react_1.default.createElement("g", null,
        react_1.default.createElement("circle", { r: 6, cx: x, cy: y, fill: color, stroke: color }),
        text && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("rect", { x: x - width / 2, y: y - (40 + verticalOffset), width: width, height: 30, rx: 14, fill: labelColor }),
            react_1.default.createElement("text", { x: x, y: y - (25 + verticalOffset), textAnchor: "middle", dominantBaseline: "middle", fontSize: fontSize, fill: textColor }, text)))));
};
const DotWithLabel = ({ x, y, text, color, textColor, labelColor, verticalOffset = 0 }) => (react_1.default.createElement(recharts_1.ReferenceDot, { x: x, y: y, r: 0, fill: "transparent", stroke: "transparent" },
    react_1.default.createElement(recharts_1.Label, { content: (props) => CustomLabel({
            viewBox: props.viewBox,
            text,
            color,
            textColor,
            labelColor,
            verticalOffset,
        }) })));
exports.DotWithLabel = DotWithLabel;
